import { apiService } from "../../services/apiService";
import { utilService } from "../../services/utilService";
import { apiServiceConstants } from "../../constants";


const addCasePatient = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `ems/case-patient/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const userListResp = res as any;
      const result: any = {
        isSuccess: userListResp.isSuccess,
        result: userListResp.result,
        status: userListResp.status,
        message: userListResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });
  return respApiResult;
};
// get-ems-sites
const getTypesList = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `ems/get-case-types/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const userListResp = res as any;
      const result: any = {
        isSuccess: userListResp.isSuccess,
        result: userListResp.result,
        status: userListResp.status,
        message: userListResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });
  return respApiResult;
};

const getSitesList = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `ems/ems-city-site-list/?search=&city_id=${params}&global=true&reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const userListResp = res as any;
      const result: any = {
        isSuccess: userListResp.isSuccess,
        result: userListResp.result,
        status: userListResp.status,
        message: userListResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });
  return respApiResult;
};

const getStateList = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `ems/ems-state-list/?search=&global=true&reg_code=${params.reg_code}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const userListResp = res as any;
      const result: any = {
        isSuccess: userListResp.isSuccess,
        result: userListResp.result,
        status: userListResp.status,
        message: userListResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });
  return respApiResult;
};

const getCityList = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `ems/ems-state-city-list/?search=&state_id=${params}&global=true&reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const userListResp = res as any;
      const result: any = {
        isSuccess: userListResp.isSuccess,
        result: userListResp.result,
        status: userListResp.status,
        message: userListResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });
  return respApiResult;
};

const getETAList = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `ems/ems-eta-list/`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const userListResp = res as any;
      const result: any = {
        isSuccess: userListResp.isSuccess,
        result: userListResp.result,
        status: userListResp.status,
        message: userListResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });
  return respApiResult;
};

const getAgeList = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `ems/ems-age-range-list/`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const userListResp = res as any;
      const result: any = {
        isSuccess: userListResp.isSuccess,
        result: userListResp.result,
        status: userListResp.status,
        message: userListResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });
  return respApiResult;
};

const getAgeUnitList = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `ems/ems-age-unit-list/`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const userListResp = res as any;
      const result: any = {
        isSuccess: userListResp.isSuccess,
        result: userListResp.result,
        status: userListResp.status,
        message: userListResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });
  return respApiResult;
};

export const PatientFormService = {
  addCasePatient,
  getTypesList,
  getSitesList,
  getStateList,
  getCityList,
  getETAList,
  getAgeList,
  getAgeUnitList,
};
